import React, { Suspense, useEffect, useCallback, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setFilters, resetFilters} from 'reducers/filtersSentInicidentsSlice';
import { resetPagination } from 'reducers/paginationSentEmailsSlice';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import TableSortingInicidentList  from "pages/sentincidents/SortingTablesInicidentsList";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews"; 
import IncidentEmailView from "pages/sentincidents/IncidentEmailView.jsx";
import IncidentEmailEdit from "pages/sentincidents/IncidentEmailEdit";
import PropTypes from 'prop-types';

const initialFilters= {
  "idFrom":"",
  "idTo":"",
  "defaultStoreIdFrom":"",
  "defaultStoreIdTo":"",
  "formdiFrom":"",
  "formdiTo":"",
  "purchaseFrom":"",
  "purchaseTo":"",
  "dateEmailFrom":null,
  "dateEmailTo":null,
  "store_IdToFrom":"",
  "store_IdToTo":"", 
  "slatypeFromES":"",
  "slatypeToES":"",
  "slatypeFromEN":"",
  "slatypeToEN":"",
  "incidenttypeFromES":"",
  "incidenttypeToES":"",
  "incidenttypeFromEN":"",
  "incidenttypeToEN":"",
  "resolutiontypeFromES":"",
  "resolutiontypeToES":"",
  "resolutiontypeFromEN":"",
  "resolutiontypeToEN":"",
  "isfinished":true,
  "notisfinished":true,
  "hasbeenread":true,
  "nothasbeenread":true
};

const initialState = [{
  "id":"",
  "defaultStore_id":0, 
  "tradename": "",
  "useraccount_id":0,
  "username": "", 
  "createdate": null,
  "emailto":"gestrescan@gmail.com",
  "subjectEmail":"", 
  "contentEmail":"",
  "resolution":"",
  "slatype_id":0,
  "slatype_namees": "",
  "slatype_nameen": "",
  "incidenttype_id":1, 
  "incidenttype_namees": "",
  "incidenttype_nameen": "",
  "resolution_id":0, 
  "resolution_namees": "",
  "resolution_nameen": "",
  "formdi_id":0, 
  "ownformdi_id": "",
  "numberDI_sheet": "",
  "purchase_id": "",
  "ownpurchase_id": "",
  "isfinished": false,
  "hasbeenread": false,
  "updatedFiles":[]
 }];

const headCells = [ 
  {
    id: 'createdate',
    numeric: false,
    disablePadding: false,
    label: 'Text_EMAIL_Date',
    canOrder:true,
  },
  {
    id: 'emailto',
    numeric: false,
    disablePadding: false,
    label: 'Text_EMAIL_Email',
    canOrder:true,
  },
  {
    id: 'subjectEmail',
    numeric: false,
    disablePadding: false,
    label: 'Text_SENDINCIDENT_SUBJECT',
    canOrder:true,
  },
  {
    id: 'incidenttype_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_SENDINCIDENT_INICIDENTTYPES',
    canOrder:true,
  },
  {
    id: 'ownformdi_id',
    numeric: true,
    disablePadding: false,
    label: 'Text_Filter_EMAIL_FormDi',
    canOrder:true,
  },
  {
    id: 'numberDI_sheet',
    numeric: true,
    disablePadding: false,
    label: 'Text_FORM_NUM_DI',
    canOrder:true,
  },
  {
    id: 'ownpurchase_id',
    numeric: true,
    disablePadding: false,
    label: 'Text_Filter_EMAIL_Purchase',
    canOrder:true,
  },
  {
    id: 'isfinished',
    numeric: false,
    disablePadding: false,
    label: 'Text_SENDINCIDENT_END',
    canOrder:true,
  }
];
 
 
const initialTypesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const IncidentList = ({showModalSentInicidents, setShowModalSentInicidents}) => {
  const {t, i18n} = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);   
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesizetickes);
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);   
  const [data, setData] = useState(initialState); 
  const filtersSentIncidentsDetails = useSelector((state) => state.filtersSentIncidents);
  const [filtersSentIncidents, setFiltersSentIncidents]= useState(initialFilters); 
  const [numTotReg,setNumTotReg]= useState(0);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [errorsFilters, setErrorsFilters] = useState({}); 
  const [inputText, setInputText] = useState("");
  const [openDeleteRow,setOpenDeleteRow]= useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const [openViewRow,setOpenViewRow]= useState(false);
  const [openEditRow,setOpenEditRow]= useState(false);
  const [openEditFilter,setOpenEditFilter]= useState(false);
  const [rowEdit,setRowEdit]= useState(initialState[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const dispatch = useDispatch();
  const [activeOffset, setActiveOffset]= useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(1);
  const [rangeOffset, setRangeOffset] = useState([{}]);  
  const [incidenteTypeToSelect,setIncidenteTypeToSelect]= useState(initialTypesToSelect); 
  
  const navigate = useNavigate(); 

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalSentInicidents) {
        setData(initialState);  
        setNumTotReg(0);
        setNumTotRegFilter(0);
        setErrorsFilters({}); 
        setInputText(""); 
        setOpenDeleteRow(false);
        setIdCodeDelete(DELETE_CODE);
        setOpenEditFilter(false);
        setRowEdit(initialState[0]);
        setOpenEditRow(false); 
        setOpenViewRow(false); 
        setIsLoadingError(false); 
        setActiveOffset(false);
        setCurrencyOffset(1);
        setRangeOffset([{}]);  
        setIncidenteTypeToSelect(initialTypesToSelect);  
        setShowModalSentInicidents(false);
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFiltersSentIncidents(initialFilters); 
        navigate("/home");
        return () => {};
      }
    },
    [
      setData, 
      setFiltersSentIncidents, 
      setNumTotReg,
      setNumTotRegFilter,
      setErrorsFilters, 
      setInputText, 
      setOpenDeleteRow,
      setOpenEditFilter,
      setRowEdit,
      setIdCodeDelete,  
      setOpenEditRow,
      setOpenViewRow,
      setIsLoadingError, 
      setActiveOffset,
      setCurrencyOffset,
      setRangeOffset,  
      setIncidenteTypeToSelect, 
      showModalSentInicidents, 
      setShowModalSentInicidents,
      navigate,
      dispatch,
      DELETE_CODE
    ]
  );

  const closeModalSendINCIDENTSSettings = () => {    
    setData(initialState); 
    setFiltersSentIncidents(initialFilters);
    setNumTotReg(0);
    setNumTotRegFilter(0);
    setErrorsFilters({}); 
    setInputText(""); 
    setOpenDeleteRow(false);
    setOpenEditRow(false);
    setOpenViewRow(false); 
    setIdCodeDelete(DELETE_CODE);
    setOpenEditFilter(false);
    setRowEdit(initialState[0]); 
    setIsLoadingError(false); 
    setActiveOffset(false);
    setCurrencyOffset(1);
    setRangeOffset([{}]);  
    setIncidenteTypeToSelect(initialTypesToSelect);  
    setShowModalSentInicidents(false);
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersSentIncidents(initialFilters); 
    navigate("/home");
    return () => {};
   };
 
  const openEditFilters = () => {
    setOpenEditFilter(!openEditFilter);
  };

  const handleSubmitFilterEdit = () => {
    setErrorsFilters(validateFormFilter());
    if (Object.keys(errorsFilters).length === 0) {
      setErrorsFilters({});
      dispatch(resetPagination());
      dispatch(setFilters(filtersSentIncidents)); 
      setOpenEditFilter(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  
  const handleDeleteFilters = () => {
    setErrorsFilters({});
    dispatch(resetPagination());
    dispatch(resetFilters()); 
    setFiltersSentIncidents(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleCancelFilters = () => {
    setErrorsFilters({});
    setOpenEditFilter(!openEditFilter);
  };
 
  const handleChangeFilterEdit = (e) => {
    const { name, value } = e.target;
    setFiltersSentIncidents(filtersSentIncidents => ({
      ...filtersSentIncidents,
      [name]: value
    }));
  };

  const handleBlurFilterEdit = (e) => {
    setErrorsFilters(validateFormFilter());
    handleChangeFilterEdit(e);
  };

  const handleBlurSelectDateFrom = (e) => {
    handleChangeSelectDateFrom(e);
    setErrorsFilters(validateFormFilter()); 
  };

  const handleChangeSelectDateFrom = (event) => {
    setFiltersSentIncidents(filtersSentIncidents => ({
      ...filtersSentIncidents,
      dateEmailFrom: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateTo = (e) => {
    handleChangeSelectDateTo(e);
    setErrorsFilters(validateFormFilter()); 
  };

  const handleChangeSelectDateTo = (event) => {
    setFiltersSentIncidents(filtersSentIncidents => ({
      ...filtersSentIncidents,
      dateEmailTo: event!==null?new Date(event):null
    }));
  };
  

  const handleChangeHasBeenEnded = (e) => {
    setFiltersSentIncidents(filtersSentIncidents => ({
      ...filtersSentIncidents,
      isfinished: !filtersSentIncidents.isfinished
    }));
  };

  const handleChangeHasNotBeenEnded = (e) => {
    setFiltersSentIncidents(filtersSentIncidents => ({
      ...filtersSentIncidents,
      notisfinished: !filtersSentIncidents.notisfinished
    }));
  };

  const toggleDrawerFilterEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      setErrorsFilters({});
      setFiltersSentIncidents(initialFilters);
      setOpenEditFilter(!openEditFilter);
    }
  };

  const validateFormFilter = () => {
    let errorsFilters = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersSentIncidents.idFrom!=="" & !regexNumber.test(filtersSentIncidents.idFrom)) {
      errorsFilters.idFrom = 'Text_TextNoNumber';
    }
    if (filtersSentIncidents.idTo!=="" & !regexNumber.test(filtersSentIncidents.idTo)) {
      errorsFilters.idTo = 'Text_TextNoNumber';
    }

    if (filtersSentIncidents.formdiFrom!=="" & !regexNumber.test(filtersSentIncidents.formdiFrom)) {
      errorsFilters.formdiFrom = 'Text_TextNoNumber';
    }
    if (filtersSentIncidents.formdiTo!=="" & !regexNumber.test(filtersSentIncidents.formdiTo)) {
      errorsFilters.formdiTo = 'Text_TextNoNumber';
    }
    if (filtersSentIncidents.formdiTo!=="" & filtersSentIncidents.formdiTo<filtersSentIncidents.formdiFrom){
      errorsFilters.formdiTo = 'Text_TextGreaterFormDI';
    }

    if (filtersSentIncidents.purchaseFrom!=="" & !regexNumber.test(filtersSentIncidents.purchaseFrom)) {
      errorsFilters.purchaseFrom = 'Text_TextNoNumber';
    }
    
    if (filtersSentIncidents.purchaseTo!=="" & !regexNumber.test(filtersSentIncidents.purchaseTo)) {
      errorsFilters.purchaseTo = 'Text_TextNoNumber';
    }
    
    if (filtersSentIncidents.purchaseTo!=="" & filtersSentIncidents.purchaseTo<filtersSentIncidents.purchaseFrom){
      errorsFilters.purchaseTo = 'Text_TextGreaterPurchase';
    }

    if (filtersSentIncidents.idFrom!=="" & !errorsFilters.idFrom!==undefined){
      if (filtersSentIncidents.idTo!=="" & !errorsFilters.idTo!==undefined){
        if (parseInt(filtersSentIncidents.idTo)<parseInt(filtersSentIncidents.idFrom)){
          errorsFilters.idTo = 'Text_TextGreater_Id';
        }
      }
    } 
    
    if (regexInvalidCharacters.test(filtersSentIncidents.store_IdToFrom)) {
      errorsFilters.store_IdToFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSentIncidents.store_IdToTo)) {
      errorsFilters.store_IdToTo = 'Text_TextNoValid';
    } 
    
     if (filtersSentIncidents.store_IdToTo!=="" & filtersSentIncidents.store_IdToTo<filtersSentIncidents.store_IdToFrom){
      errorsFilters.store_IdToTo = 'Text_TextGreater_Email';
    }
    
    return errorsFilters;
  }  

  const filteredData = data.filter((el) => {
    if (inputText === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.emailto || '') +
        String(el.subjectEmail || '');
      let result = dataTranslate.toLowerCase().includes(inputText.toLowerCase());
      return result;
    }
  })

  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };
 
  const handleCloseDataEdit = () => { 
    setOpenDeleteRow(false); 
    setRowEdit(initialState[0]); 
    dispatch(setLoading(false));
    setIsLoadingError(false); 
    toggleDrawerDataEdit(false);
	}; 
 
  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };
  
  const handleCancelDeleteRow = () => {
    setRowEdit(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
  };

  const handleCloseDeleteRow = (e) => {
    if (idCodeDelete !== DELETE_CODE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEdit.id !== '') {
     
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `incidentemail/deletesentincident`, token, rowEdit);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false)); 
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
        }; 
        fetchData(); 
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
    handleCloseDataEdit();
    return () => { isMounted = false;};
  };
  
  const toggleDrawerDataEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault()
      handleCloseDataEdit();
    }
  };
 
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (numTotRegFilter>LIMITPAGESIZE){
      setActiveOffset(true);
      setRangeOffset([
        { value: 0,
          label: " 1 - "+Number(LIMITPAGESIZE).toLocaleString('de-DE'),
        }
      ]);
      for (let i = Number(LIMITPAGESIZE); i<numTotRegFilter; i=i+ Number(LIMITPAGESIZE)){
        setRangeOffset(
          current=>[
            ...current,
            ...[
              {
                value: i,
                label: " "+(i+1).toLocaleString('de-DE')+" - "+(i+Number(LIMITPAGESIZE)).toLocaleString('de-DE'),
              }
            ]
          ]
        )
      }
    } else{
      setCurrencyOffset(0);
      setActiveOffset(false);
      setRangeOffset([{}]);
    }
  },[numTotRegFilter,LIMITPAGESIZE]);

  useEffect(() => {
    let isMounted = true;  
    const fetchDataIncident = async () => {
      try {
        const getData = i18n.language==='es'?
          await helpHttp().get(ENDPOINT,`incidenttype/incidenttypesorderbynamees`,token):
          await helpHttp().get(ENDPOINT,`incidenttype/incidenttypesorderbynameen`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setIncidenteTypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
     

    if (setShowModalSentInicidents ) {  
      fetchDataIncident(); 
    }
    return () => { isMounted = false };

  }, [t,token,i18n,dispatch,roles,setShowModalSentInicidents,defaultStore.id]);
   
  
  useEffect(() => {
    let ignore = false;  
    const fetchnumTotReg = async () => {
      try {
         const getData  = (roles[0].listmenus.find((key)=>(key.name==='View_INCIDENTSEMAILS_ALL_STORES')))
                ? await helpHttp().get(ENDPOINT,`incidentemail/geiInformationtablesentincident`,token) 
                :  await helpHttp().get2(ENDPOINT,`incidentemail/getinformationtablesentincidentwithstore/`,token,defaultStore.id);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotReg(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchnumTotRegFilter = async () => { 
      try {
        const getData  = (roles[0].listmenus.find((key)=>(key.name==='View_INCIDENTSEMAILS_ALL_STORES')))
                ? await helpHttp().post2(ENDPOINT, `incidentemail/getcountfiltersentincident`, token, "-1",filtersSentIncidentsDetails)
                :  await helpHttp().post2(ENDPOINT, `incidentemail/getcountfiltersentincident`, token, defaultStore.id,filtersSentIncidentsDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        const getData  = (roles[0].listmenus.find((key)=>(key.name==='View_INCIDENTSEMAILS_ALL_STORES')))
            ? await helpHttp().post4(ENDPOINT,`incidentemail/getsentincidents`,token,currencyOffset,LIMITPAGESIZE,"-1",filtersSentIncidentsDetails)
            : await helpHttp().post4(ENDPOINT,`incidentemail/getsentincidents`,token,currencyOffset,LIMITPAGESIZE,defaultStore.id,filtersSentIncidentsDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setData(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    if (showModalSentInicidents) {
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchData();
      return () => { ignore = true; };
    }
  }, [ t, token, dispatch,LIMITPAGESIZE,openDeleteRow,roles,defaultStore.id,showModalSentInicidents, filtersSentIncidentsDetails, currencyOffset,openEditRow]);
  
  return (
    <>
      {showModalSentInicidents ? ( 
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingError?
              <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>
              :isLoadingData?
              <CircularProgress color={"primary"}/>:
              <i className="fas fa-solid fa-inbox text-warning"></i>} {t('Text_SENDINCIDENT_List')}
            </h1>
            {isLoadingData ?
              <CircularProgress sx={{ color : "#f6c23e"}}/>:
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalSendINCIDENTSSettings} >
                  {t('Button_Back')}
                </button> 
            } 
          </div>  
          <br/>  
          {!isLoadingData ?
          <>
            {/* Buscador */}
            <div className="formdi-pending-search">
              <TextField
                id="outlined-basic"
                variant="outlined"
                value={inputText}
                inputProps={{ style: {fontSize: '18px'} }}
                InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
                placeholder={t('Text_SENDINCIDENTL_Search')}
                onChange={inputHandler}
                fullWidth
                label={t('Text_SENDINCIDENTL_Search')}>
              </TextField>
            </div>
            <br/>
            <div id="myNewDIV" className="formdi-pending-filters">
              <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
              <div className="formdi-pending-filters-row">
                 {roles[0].listmenus.find((key)=>(key.name==='View_INCIDENTSEMAILS_ALL_STORES'))&&
                  <>
                    <button type="button" className={`formdi-pending-chip ${filtersSentIncidentsDetails.store_IdToFrom !== "" || filtersSentIncidentsDetails.store_IdToTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                      <span className={`formdi-pending-dot ${ filtersSentIncidentsDetails.store_IdToFrom !== "" || filtersSentIncidentsDetails.store_IdToTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_EMAIL_Table")}
                    </button>
                  </>
                }
                <button type="button" className={`formdi-pending-chip ${filtersSentIncidentsDetails.formdiFrom!=="" || filtersSentIncidentsDetails.formdiTo!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${filtersSentIncidentsDetails.formdiFrom!=="" || filtersSentIncidentsDetails.formdiTo!==""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Filter_EMAIL_FormDi")}
                </button>

                 <button type="button" className={`formdi-pending-chip ${filtersSentIncidentsDetails.purchaseFrom!=="" || filtersSentIncidentsDetails.purchaseTo!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${filtersSentIncidentsDetails.purchaseFrom!=="" || filtersSentIncidentsDetails.purchaseTo!==""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Filter_EMAIL_Purchase")}
                </button>

                <button type="button" className={`formdi-pending-chip ${filtersSentIncidentsDetails.dateEmailFrom!==null || filtersSentIncidentsDetails.dateEmailTo!==null ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${filtersSentIncidentsDetails.dateEmailFrom!==null || filtersSentIncidentsDetails.dateEmailTo!==null? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDINCIDENT_Date")}
                </button>
                <button type="button" className={`formdi-pending-chip ${(filtersSentIncidentsDetails.incidenttypeFromES!=="" || filtersSentIncidentsDetails.incidenttypeToES!=="" || filtersSentIncidentsDetails.incidenttypeFromEN!=="" || filtersSentIncidentsDetails.incidenttypeToEN!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${(filtersSentIncidentsDetails.incidenttypeFromES!=="" || filtersSentIncidentsDetails.incidenttypeToES!=="" || filtersSentIncidentsDetails.incidenttypeFromEN!=="" || filtersSentIncidentsDetails.incidenttypeToEN!=="")? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDINCIDENT_INICIDENTTYPES")}
                </button>  
                <button type="button" className={`formdi-pending-chip ${filtersSentIncidentsDetails.hasbeenread ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ filtersSentIncidentsDetails.hasbeenread? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDINCIDENT_END")}
                </button>  
                 <button type="button" className={`formdi-pending-chip ${filtersSentIncidentsDetails.hasbeenread ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ filtersSentIncidentsDetails.nothasbeenread? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_SENDINCIDENT_NOTEND")}
                </button>  
              </div>
            </div>
            <br/>
           <div className="formdi-pending-card-flat">
              <div className="formdi-pending-card-content">
                <TableSortingInicidentList
                  data={filteredData}
                  headCells={headCells}
                  numTotRegFilter={numTotRegFilter}
                  titleTable={t('Text_SENDINCIDENT_Table')}
                  setOpenDeleteRow={setOpenDeleteRow}
                  setOpenViewRow={setOpenViewRow}
                  setOpenEditRow={setOpenEditRow}
                  setRowEdit={setRowEdit}
                  showEditButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_INCIDENTSEMAILS_Edit'))?true:false}
                  showDeleteButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_INCIDENTSEMAILS_Delete'))?true:false}
                  numTotReg={numTotReg}
                  activeOffset={activeOffset}
                  rangeOffset={rangeOffset}
                  currencyOffset={currencyOffset}
                  setCurrencyOffset={setCurrencyOffset}
                >
                </TableSortingInicidentList>
              </div>             
            </div>
            {openEditFilter &&
              <div>
                <SwipeableDrawer
                  anchor='right'
                  open={true}
                  onClose={toggleDrawerFilterEdit(false)}
                  onOpen={toggleDrawerFilterEdit(true)}>
                  <Container >
                    <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                      <br/>
                      <div id="myDIV">
                        <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                      </div>
                      <hr className="sidebar-divider d-none d-md-block"/>
                      <form className="createfilter" onSubmit={handleCancelFilters}>  
                        <div className="form-floating mb-3 px-4 primary">
                          <div className="form-group">
                            <TextField
                              id="formdiFrom"
                              name="formdiFrom"
                              value={filtersSentIncidents.formdiFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.formdiFrom!=null?t(errorsFilters.formdiFrom):t('Text_Filter_EMAIL_FormDiFrom')}
                              placeholder={t('PlaceHolder_Filter_EMAIL_FormDiFrom')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit} 
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id="formdiTo"
                              name="formdiTo"
                              value={filtersSentIncidents.formdiTo}  
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.formdiTo!=null?t(errorsFilters.formdiTo):t('Text_Filter_EMAIL_FormDiTo')}
                              placeholder={t('PlaceHolder_Filter_EMAIL_FormDiTo')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}
                            />
                          </div> 
                        </div> 
                        <div className="form-floating mb-3 px-4 primary">
                          <div className="form-group">
                            <TextField
                              id="purchaseFrom"
                              name="purchaseFrom"
                              value={filtersSentIncidents.purchaseFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.purchaseFrom!=null?t(errorsFilters.purchaseFrom):t('Text_Filter_EMAIL_PurchaseFrom')}
                              placeholder={t('PlaceHolder_Filter_EMAIL_PurchaseFrom')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit} 
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id="purchaseTo"
                              name="purchaseTo"
                              value={filtersSentIncidents.purchaseTo}  
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.purchaseTo!=null?t(errorsFilters.purchaseTo):t('Text_Filter_EMAIL_PurchaseTo')}
                              placeholder={t('PlaceHolder_Filter_EMAIL_PurchaseTo')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}
                            />
                          </div> 
                        </div> 
                        <div className="form-floating mb-3 px-4 primary">
                          <div className="form-group">
                            <TextField
                              id="store_IdToFrom"
                              name="store_IdToFrom"
                              value={filtersSentIncidents.store_IdToFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.store_IdToFrom!=null?t(errorsFilters.store_IdToFrom):t('Text_Filter_Email_From')}
                              placeholder={t('PlaceHolder_Filter_Email_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit} 
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id="store_IdToTo"
                              name="store_IdToTo"
                              value={filtersSentIncidents.store_IdToTo}  
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.store_IdToTo!=null?t(errorsFilters.store_IdToTo):t('Text_Filter_Email_to')}
                              placeholder={t('PlaceHolder_Filter_Email_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}
                            />
                          </div> 
                          <div className="form-group">
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                id="dateEmailFrom" 
                                name="dateEmailFrom"
                                value={ filtersSentIncidents.dateEmailFrom!== null ? new Date(filtersSentIncidents.dateEmailFrom): null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                label={errorsFilters.dateEmailFrom!=null?t(errorsFilters.dateEmailFrom):t('Text_Filter_EMAIL_Date_From')}
                                onBlur={handleBlurSelectDateFrom}
                                onChange={handleChangeSelectDateFrom}
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                    sx: {
                                      color: '#1565c0',
                                      maxLength: '100',
                                      width: 430,  
                                      fontSize: '18px'
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                id="dateEmailTo" 
                                name="dateEmailTo"
                                minDate={filtersSentIncidents.dateEmailFrom!== null ? new Date(filtersSentIncidents.dateEmailFrom): null}
                                value={ filtersSentIncidents.dateEmailTo!== null ? new Date(filtersSentIncidents.dateEmailTo): null}
                                format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                label={errorsFilters.dateEmailTo!=null?t(errorsFilters.dateEmailTo):t('Text_Filter_EMAIL_Date_To')}
                                onBlur={handleBlurSelectDateTo}
                                onChange={handleChangeSelectDateTo}
                                slotProps={{
                                  textField: {
                                    placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                    sx: {
                                      color: '#1565c0',
                                      maxLength: '100',
                                      width: 430,  
                                      fontSize: '18px'
                                    },
                                    InputProps: {
                                      style: {
                                        fontSize: '18px',
                                      }
                                    },
                                    InputLabelProps:{ 
                                      style: {
                                        fontSize: '18px', 
                                        background: '#FFFFFF'
                                      }
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </div>     
                          <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                            <div className="form-group">
                              <TextField
                                id={i18n.language==="es"?"incidenttypeFromES":"incidenttypeFromEN"}
                                name={i18n.language==="es"?"incidenttypeFromES":"incidenttypeFromEN"}
                                value={i18n.language==="es"?filtersSentIncidents.incidenttypeFromES:filtersSentIncidents.incidenttypeFromEN}
                                inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={i18n.language==="es"?errorsFilters.incidenttypeFromES!=null?t(errorsFilters.incidenttypeFromES):t('Text_Filter_SENDINCIDENT_INICIDENTTYPES_From'):errorsFilters.incidenttypeFromEN!=null?t(errorsFilters.incidenttypeFromEN):t('Text_Filter_SENDINCIDENT_INICIDENTTYPES_From')}
                                placeholder={t('PlaceHolder_Filter_SENDINCIDENT_INICIDENTTYPES_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit}
                                select
                                SelectProps={{
                                native: true,
                                }}>
                                <option key={0} value=""/>
                                {incidenteTypeToSelect.map((option) => (
                                <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <TextField
                                id={i18n.language==="es"?"incidenttypeToES":"incidenttypeToEN"}
                                name={i18n.language==="es"?"incidenttypeToES":"incidenttypeToEN"}
                                value={i18n.language==="es"?filtersSentIncidents.incidenttypeToES:filtersSentIncidents.incidenttypeToEN}
                                inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                label={i18n.language==="es"?errorsFilters.incidenttypeToES!=null?t(errorsFilters.incidenttypeToES):t('PlaceHolder_Filter_SENDINCIDENT_INICIDENTTYPES_To'):errorsFilters.incidenttypeToES!=null?t(errorsFilters.incidenttypeToES):t('PlaceHolder_Filter_SENDINCIDENT_INICIDENTTYPES_To')}
                                placeholder={t('PlaceHolder_Filter_SENDINCIDENT_INICIDENTTYPES_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit}
                                select
                                SelectProps={{
                                native: true,
                                }}>
                                <option key={0} value=""/>
                                {incidenteTypeToSelect.filter(item=>(i18n.language==="es"?item.namees>=filtersSentIncidents.incidenttypeFromES:item.nameen>=filtersSentIncidents.incidenttypeFromEN)).map(option => (
                                <option key={option.id} value={i18n.language==="es"?option.namees:option.nameen}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                                ))}
                              </TextField>
                            </div> 
                            <div className="form-group">
                              <Checkbox
                                id="isfinished" 
                                name="isfinished"
                                checked={filtersSentIncidents.isfinished}
                                onChange={handleChangeHasBeenEnded}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDINCIDENT_END')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                id="notisfinished" 
                                name="notisfinished"
                                checked={filtersSentIncidents.notisfinished}
                                onChange={handleChangeHasNotBeenEnded}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SENDINCIDENT_NOTEND')}</label>    
                          </div> 
                          </Suspense>
                          <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEdit}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFilters}>
                              {t('Button_Cancel_Filters')}
                            </button>
                          </div> 
                        </div>
                      </form>
                    </Box>
                  </Container>
                </SwipeableDrawer>
              </div>
            }
            <IncidentEmailView
              openViewRow={openViewRow}
              setOpenViewRow={setOpenViewRow}
              rowEdit={rowEdit}
              >
            </IncidentEmailView>
            <IncidentEmailEdit
              openEditRow={openEditRow}
              setOpenEditRow={setOpenEditRow}
              rowEdit={rowEdit}
            >
            </IncidentEmailEdit>
            <Dialog open={openDeleteRow} onClose={handleCancelDeleteRow} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {rowEdit.id}  - {rowEdit.emailto} 
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDelete}
                      onChange={handleChangeDeleteRow}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRow}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRow}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>    
            {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

IncidentList.propTypes = {
  showModalSentInicidents: PropTypes.bool.isRequired,
  setShowModalSentInicidents: PropTypes.func.isRequired   
};

export default IncidentList;